//Admin

import Admin from './Admin/Admin';

import CheckWeight from './Admin/CheckWeight';
import UploadCheckWeight from './Admin/UploadCheckWeight'
import Requested from './Admin/Requested';
import RequestDaily from './Admin/RequestDaily'
import RequestEditCalendar from './Admin/RequestEditCalendar'
import RequestEditTable from './Admin/RequestEditTable'
import RequestEdit from './Admin/RequestEdit'
import FinancialAccount from './Admin/FinancialAccount';
import RequestCalendar from './Admin/RequestCalendar'
import RequestMemCalendar from './Admin/RequestMemCalendar'
import RequestMemDaily from './Admin/RequestMemDaily'
import RequestTable from './Admin/RequestTable'
import RequestDate from './Admin/RequestDate'
import CheckWeightCalendar from './Admin/CheckWeightCalendar'
import CheckWeightTable from './Admin/CheckWeightTable'
import ViewCheckWeight from './Admin/ViewCheckWeight'
import Job from './Admin/Job';
import HealthCert from './Admin/HealthCert'
import Request from './Admin/Request';
import FinancialWageCalendar from './Admin/FinancialWageCalendar'
import FinancialWageTable from './Admin/FinancialWageTable'
import FinancialWageSetting from './Admin/FinancialWageSetting'
import AddJob from './Admin/AddJob';
import AddSurvey from './AdminSystem/AddSurvey'
import JobCalendar from './Admin/JobCalendar'
import JobSummary from './Admin/JobSummary'
import ValidateCheckWeight from './Admin/ValidateCheckWeight';

import ValidateFinancial from './Admin/ValidateFinancial';

import ValidPageTable from './Admin/ValidPageTable';
import ValidCalendar from './Admin/ValidCalendar'
import ValidatePage from './Admin/ValidatePage';

import Certificate from './Admin/Certificate';

import CertiPage from './Admin/CertiPage';
import FinancialWageMonthlyTable from './Admin/FinancialWageMonthlyTable'
import CertificateCalendar from './Admin/CertificateCalendar'
import CertificateTable from './Admin/CertificateTable'
import SumCertificate from './Admin/SumCertificate'
// import Statistics from './Admin/Statistics';
import Statistics from './Admin/Statistics_new';

import CertificateRequested from './Admin/CertificateRequested'
import FinancialWageVehicle from './Admin/FinancialWageVehicle'
import FinancialWageMonthlyTableMonthly from './Admin/FinancialWageMonthlyTableMonthly'
//AdminSystem
import FinancialCompany from './Admin/FinancialCompany'
import AddCompany from './AdminSystem/AddCompany';

import EditCompany from './AdminSystem/EditCompany';

import AddOfficer from './AdminSystem/AddOfficer';

import EditOfficer from './AdminSystem/EditOfficer';

import AddRice from './AdminSystem/AddRice';

import EditRice from './AdminSystem/EditRice';

import AdminSys from './AdminSystem/AdminSys';

import EditProfile from './AdminSystem/EditProfile';

import EditSurvey from './AdminSystem/EditSurvey'
//Guest

import Guest from './Guest/Guest';

//Landing

import Landing from './Landing/Landing';

//Login

import Login from './Login/Login';

//Officer

import Officer from './Officer/Officer';

//Surveyor

import Surveyor from './Surveyor/Surveyor';

//Warning

import Warning500 from './Warning/Warning500';

import Warning404 from './Warning/Warning404';
import testExcel from './Admin/excelfordb'
export {
  //admin
  Admin,
  CheckWeight,
  FinancialAccount,
  Job,
  JobCalendar,
  Request,
  AddJob,
  ValidateCheckWeight,
  ValidateFinancial,
  ValidPageTable,
  ValidatePage,
  Certificate,
  CertiPage,
  Statistics,
  //adminsystem
  AddCompany,
  AddOfficer,
  AddRice,
  AdminSys,
  EditCompany,
  EditOfficer,
  EditProfile,
  EditRice,
  //Guest
  Guest,
  //Landing
  Landing,
  //Login
  Login,
  //Officer
  Officer,
  //Surveyor
  Surveyor,
  //Warning
  Warning500,
  Warning404,
  Requested,
  RequestDaily,
  RequestEditCalendar,
  RequestEditTable,
  RequestEdit,
  RequestCalendar,
  RequestMemCalendar,
  RequestMemDaily,
  RequestTable,
  RequestDate,
  CheckWeightCalendar,
  CheckWeightTable,
  CertificateCalendar,
  CertificateTable,
  UploadCheckWeight,
  ViewCheckWeight,
  HealthCert,
  ValidCalendar,
  FinancialWageCalendar,
  FinancialWageTable,
  EditSurvey,
  SumCertificate,
  CertificateRequested,
  FinancialWageMonthlyTable,
  FinancialWageSetting,
  AddSurvey,
  FinancialWageVehicle,
  FinancialWageMonthlyTableMonthly,
  testExcel,
  FinancialCompany,
  JobSummary
};
